import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=ff54a430&lang=pug&"
import script from "./Home.vue?vue&type=script&lnag=ts&lang=js&"
export * from "./Home.vue?vue&type=script&lnag=ts&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports